/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Recovery_Wheel_EfficiencyInputs */



/**
* | output |
* | --- |
* | "Recovery wheel efficiency" |
*
* @param {Air_Handler_Unit_Recovery_Wheel_EfficiencyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_recovery_wheel_efficiency = /** @type {((inputs?: Air_Handler_Unit_Recovery_Wheel_EfficiencyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Recovery_Wheel_EfficiencyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Recovery wheel efficiency")
	return /** @type {LocalizedString} */ ("Rendement de la roue de récupération")
});